import React, { useEffect, useState } from "react";
import { useDispatch, useSelector  } from "react-redux";
import { getDataList } from "../redux/actions/ContentActions";
import { CartAddAction } from "../redux/actions/PaymentActions";
import { useParams, Link , useNavigate} from "react-router-dom";
import { Helmet } from 'react-helmet';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast } from "react-toastify";
import ToastDefault from "../components/Toast";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { getAuth } from "../utils/Helper";


type SeoContent = {
  meta_title: string;
  meta_description?: string;
  name: string;
  single_line: string;
  payment_note : string;
  // Add more fields as needed
};

const Listing: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const auth = getAuth();
  const { slug } = useParams<{ slug: string }>();
  const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
  const [settingContent, setSettingContent] = useState(null);
  const data = useSelector((state: any) => state.content.content_data || []);
  const [dataList, setDataList] = useState<any[]>([]);
  const [dataGroupList, setDataGroupList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingM, setLoadingM] = useState<boolean>(false);
  const [loadingMM, setLoadingMM] = useState<boolean>(false);
  const [subCategory, setSubCategory] = useState("");
  const [price, setPrice] = useState();

  useEffect(() => {
    setLoading(true); // Start loading
    dispatch(getDataList({ slug }));
  }, [slug])

  useEffect(() => {
    if (data?.data) {
      setDataList(data?.data);
      setDataGroupList(data?.groups)
      setSoeContent(data?.seo_data)
      setSubCategory(data?.seo_data?.id)
      setPrice(data?.seo_data?.price)
      setLoading(false); // End loading
    }
  }, [data])

  const { loading_add , status_add , data_add , error_add } = useSelector((state: any) => state.cartAddState || {});

  const handleCart = (categoryId : any , groupId : any) => {
    console.log("subCategory : ",subCategory , " ========  groupId : ",groupId)
    if(!auth){
      navigate("/login")
      return false
    }
    if(groupId){
      setLoadingMM(true);
    } else {
      setLoadingM(true);
    }
    dispatch(CartAddAction({"sub_category_id":subCategory,'group_id':groupId}))
  }

  useEffect(() => {
    if (status_add) {
      console.log("In Cart Data Added :", data_add);
      dispatch(CartAddAction("RESET"));
      //toast.success(data?.message);
      setLoadingM(false);
      setLoadingMM(false);
    }
    if (error_add) {
      dispatch(CartAddAction("RESET"));
      setLoadingM(false);
     setLoadingMM(false); 
    }
  }, [status_add, error_add]);  

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Listing of categories'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <section className="text-white text-center py-5" style={{ background: "linear-gradient(to right, #2563eb, #4f46e5)" }}>
        <div className="container">
          <h1 className="display-4 fw-bold">{soeContent?.name || 'A Path for Every Goal'}</h1>
          <p className="lead mb-4">{soeContent?.single_line || 'Top courses in AI, Data Science, and Analytics'}</p>
          <div className="row justify-content-end">
            <div className="col-lg-3 mb-1 text-end">
                            <Tooltip
                              anchorId={`cart-btn-sub-category-id`}
                              place="top"
                              content={soeContent?.payment_note || ''} />
                {
                  price  && (<button
                                id={`cart-btn-sub-category-id`}
                                className="btn btn-warning btn-lg fw-semibold shadow-sm d-flex align-items-center justify-content-center gap-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleCart(subCategory, "")}
                              >
                                {loadingM ? (
                                                  <span className="spinner-border spinner-border-sm me-2" role="status"  aria-hidden="true" ></span>
                                                ) : (
                                                  <i className="bi bi-cart3 fs-5"></i>
                                                )} Add To Cart
                              </button>)
                }
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container mb-5">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "404px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
            <div className="row g-4 py-3" >

              {dataGroupList.length > 0 ? (
                dataGroupList.map((group: any) => (
                  <div className="col-12 mb-4" key={group?.id}>
                    {/* Outer Group Box */}
                    <div className="card shadow-sm" >
                        <div className="d-flex justify-content-between align-items-center mb-3 p-2  border-btm">
                          <h4 className="mb-0">
                            <i className="fas fa-layer-group me-2"></i> {group?.name}
                          </h4>
                          {group?.price && (
                            <>
                            <Tooltip
                              anchorId={`cart-btn-${group?.id}`}
                              place="top"
                              content={group?.payment_note || ""}
                            />
                            <button
                              id={`cart-btn-${group?.id}`}
                              className="btn btn-warning btn-lg fw-semibold shadow-sm d-flex align-items-center justify-content-center gap-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleCart(subCategory, group?.id)}
                            >
                              {loadingMM ? (
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                <i className="bi bi-cart3 fs-5"></i>
                              )}
                              Add To Cart
                            </button>
                            </>
                          )}
                        </div>

                      <div className="card-body">
                        <div className="row">
                          {group?.contents?.length > 0 ? (
                            group.contents.map((course: any) => (
                              <div className="col-md-4 mb-3" key={course?.id}>
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body d-flex flex-column">
                                    <h5 className="card-title mb-3">
                                      <i className="fas fa-medal"></i> {course?.title}
                                    </h5>
                                    <p className="card-text flex-grow-1 mb-3">
                                      <span title={course?.short_description}>
                                        {course?.short_description?.length > 90
                                          ? `${course?.short_description.slice(0, 90)}...`
                                          : course?.short_description}
                                      </span>
                                    </p>
                                    <Link
                                      className="btn btn-outline-primary mt-auto"
                                      to={course?.slug}
                                    >
                                      See Details →
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (<></>)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (<></>)}

              {dataList.length > 0 ? (
                dataList.map((course: any) => (
                  <div className="col-md-4" key={course?.id}>
                    <div className="card h-200 shadow-sm">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title mb-3">
                          <i className="fas fa-medal"></i> {course?.title}
                        </h5>
                          <p className="card-text flex-grow-1 mb-3">
                              <span title={course?.short_description}>
                                {course?.short_description.length > 90 ? `${course?.short_description.slice(0, 90)}...` : course?.short_description}
                              </span>
                          </p>
                        <Link className="btn btn-outline-primary mt-auto" to={course?.slug}>
                          See Details →
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : <></>
              }

            </div>
                {/* <div className="col-12 py-3">
                  <div
                    className="alert alert-info text-center d-flex justify-content-center align-items-center"
                    role="alert"
                    style={{ height: "324px" }}
                  >
                    <h3 className="mb-0">No results found.</h3>
                  </div>
                </div> */}
            </>

          )}
        </div>
      </section>
      <ToastDefault />
      <Footer />
    </>
  );
};

export default Listing;